export const PATH_HOME = '/';
export const PATH_REGISTER = '/register';
export const PATH_LOGIN = '/login';
export const PATH_APP = '/app';
export const PATH_DOWNLOADS = `${PATH_APP}/downloads`;

export const serverRoutes = [PATH_HOME, PATH_REGISTER, PATH_LOGIN];
